import React, { FunctionComponent } from 'react'
import { majorScale, Heading, Paragraph, TextInputField, Link } from 'evergreen-ui'
import DialogLayout from '../DialogLayout'

interface VerifySmsStepProps {
  onClickBack: () => void
  onClickEnable: () => Promise<void>
  onClickResendLink: () => Promise<void>
  onTfaTokenInputChange: (value: string) => void
  displayNumber: string
}

const VerifySmsStep: FunctionComponent<VerifySmsStepProps> = ({
  onClickBack,
  onClickEnable,
  onClickResendLink,
  onTfaTokenInputChange,
  displayNumber
}) => (
  <DialogLayout onBackClick={onClickBack} onConfirmClick={onClickEnable} confirmLabel="Enable">
    <Heading size={600} marginBottom={majorScale(3)} textAlign="center">
      Verify your phone number
    </Heading>

    <TextInputField
      className="fullstory-exclude"
      type="number"
      required
      autoFocus
      placeholder="123456"
      label={`Enter the code sent to ${displayNumber}`}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onTfaTokenInputChange(e.target.value)}
      marginBottom="0"
    />
    <Paragraph size={300} color="muted" marginTop="6px">
      Didn’t get a code?{' '}
      <Link is="button" onClick={onClickResendLink} size={300} padding="0" margin="0" border="none">
        Resend code
      </Link>{' '}
      or double-check the phone number entered.
    </Paragraph>
  </DialogLayout>
)

export default VerifySmsStep
